/**
 * JSON.stringify with object keys sorted, recursively.
 *
 * Why this exists: state that round-trips through the Go server comes back with
 * its object keys alphabetically sorted, because Go marshals
 * map[string]interface{} in sorted key order. Locally built objects keep their
 * literal insertion order. Plain JSON.stringify therefore reports two
 * semantically identical shopping lists as different, which made the echo
 * suppression in App.js fail and put connected clients into an endless
 * rebuild-and-broadcast loop.
 *
 * Use this for every comparison of local state against data that came from the
 * server -- never raw JSON.stringify.
 */
export function stableStringify(value) {
  if (value === null || typeof value !== 'object') {
    const encoded = JSON.stringify(value);
    return encoded === undefined ? 'null' : encoded;
  }

  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }

  const parts = [];
  for (const key of Object.keys(value).sort()) {
    const entry = value[key];
    // Match JSON.stringify: undefined and function values are omitted
    if (entry === undefined || typeof entry === 'function') continue;
    parts.push(`${JSON.stringify(key)}:${stableStringify(entry)}`);
  }
  return `{${parts.join(',')}}`;
}
